module.exports = __webpack_public_path__ + "img/nicaragua.1b9febc8.png";